import { useNavigate } from 'react-router-dom';
import { AlertTriangle } from 'lucide-react';
import CustomAppBar from '../../../mainComponents/appBar';

export default function TermsOfUse() {
  const navigate = useNavigate();

  return (
    <div className="flex justify-center bg-[#f5f5f5] overflow-hidden no-scrollbar pt-10 h-screen px-4 py-6 text-black font-[SF Pro Display]">
      <div className="w-full max-w-sm flex flex-col">
        {/* Header */}
        <CustomAppBar
          title="Terms of Use"
        />

        {/* Icon & Header */}
        <div className="flex mt-5 items-center space-x-3 mb-4">
          <div className="bg-yellow-100 rounded-full p-2">
            <AlertTriangle className="w-5 h-5 text-yellow-600" />
          </div>
          <p className="text-base font-semibold">Read our usage terms below</p>
        </div>

        {/* Terms Content */}
        <div className="bg-white rounded-2xl p-4 space-y-4 shadow-sm text-sm text-gray-700 leading-relaxed overflow-y-auto max-h-[60vh]">
          <p>
            By using this app, you agree to use it respectfully and in accordance with our
            community guidelines. You must not send abusive, hateful, or threatening messages.
          </p>
          <p>
            Users violating these terms may be blocked, suspended, or reported. We reserve the
            right to remove any content that goes against our policies.
          </p>
          <p>
            You also agree not to misuse the platform for commercial spam or harassment. Be kind.
            Stay anonymous. Keep it safe.
          </p>
          <p>
            For full legal documents, visit our official site or contact us at squadco@gmail.com.
          </p>
        </div>

        {/* Got it button */}
        <button
          onClick={() => navigate(-1)}
          className="mt-6 bg-black text-white font-semibold text-sm py-2 rounded-full hover:bg-gray-900 transition"
        >
          Got it
        </button>
      </div>
    </div>
  );
}
